import { render, staticRenderFns } from "./dealCopyHistory.vue?vue&type=template&id=ed8ff014&"
import script from "./dealCopyHistory.vue?vue&type=script&lang=ts&"
export * from "./dealCopyHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports